import { Injectable } from '@angular/core';

/**
 * Handles the previous input value.
 */
@Injectable()
export class FormFieldEmailCheckerService {
  public storedEmailCheckerValue: string;

  constructor() { }

  public set emailCheckerValue(value: string) {
    this.storedEmailCheckerValue = value;
  }

  public get emailCheckerValue(): string {
    return this.storedEmailCheckerValue;
  }

}
